import { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import FieldEntry from '@FormFunctionalDisplay/FieldEntry';
import KaiziqResolveConnectionService from '@Helpers/URLHelpers/KaiziqResolveConnectionService';
import FieldService from '@Helpers/URLHelpers/FieldService';
import FieldPageService from '@Helpers/URLHelpers/FieldPageService';
import './FieldPage.scss';

export default function FieldPage(props) {

    const [fieldPageFieldIdList, setFieldPageFieldIdList] = useState([]);
    useMediaQuery({ maxWidth : 768});
    const [refresh, setRefresh] = useState(false);
    new KaiziqResolveConnectionService();
    new FieldService();
    new FieldPageService();
    const className = 'fieldPage';

    useEffect(() => {
        setFieldPageFieldIdList([]);
        setRefresh(!refresh);
        parseData();
    }, [props])

    const parseData = () => {
        console.log(props);
        if(!!props?.fieldPage?.details){
            setFieldPageFieldIdList(JSON.parse(props.fieldPage.fields));
            checkIsNextEnabled();
        }
    }

    const checkIsNextEnabled = () => {
        let nextDisabled = false;
        let pageFieldIdList = JSON.parse(props?.fieldPage?.fields);
        for(var i  = 0; i < pageFieldIdList.length; i++) {
            let field = props.formFieldList.find((formField) => formField.id === pageFieldIdList[i]);
            let required = JSON.parse(field?.rules)?.find((rule) => rule.type === 'required')?.value;
            if(required && (!props.fieldEntryMap || !props.fieldEntryMap[field.id])) {
                nextDisabled = true;
            }
        }
        console.log(nextDisabled);
        props.setDisableNext(nextDisabled);
    }

    return (
        <div className={className + ' width-wfa'}>
            <div className={className + '__inner width-wfa'}>
                <div className={className + '__inner__display'}>
                    <div className={className + '__inner__display__inner flex-column-center-2vh-gap'}>
                        {
                            fieldPageFieldIdList?.map((fieldId, index) =>
                                <FieldEntry
                                    fieldId={fieldId}
                                    fieldPageFieldIdList={fieldPageFieldIdList}
                                    field={props.formFieldList.find((formField) => formField.id === fieldId)}
                                    index={index}
                                    fieldPage={props.fieldPage}
                                    isNextHovered={props.isNextHovered}
                                    checkIsNextEnabled={checkIsNextEnabled}
                                    fieldEntryMap={props.fieldEntryMap}
                                    handleFieldEntryChange={props.handleFieldEntryChange}
                                    fieldBackgroundStyle={props.fieldBackgroundStyle}
                                    kaiziqResolveConnection={props.kaiziqResolveConnection}
                                    renderData={props.renderData}/>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
